import React, { useMemo } from "react";
import { RoomCategoryFilters } from "@/types/roomCategory";
import { useRoomCategoriesFiltersSettings } from "@/hooks/useRoomCategories";
import { FilterMultiSelect } from "@/components/common/FilterMultiSelect";
import { FilterSingleSelect } from "@/components/common/FilterSingleSelect";

const RoomCategoriesFilter = ({
  filters,
  actions,
  hotelId,
}: {
  hotelId: string;
  filters: RoomCategoryFilters;
  actions: {
    setCategoryId: (value: string) => void;
    setAmenities: (value: string[]) => void;
    handleFilterChange: <T>(setter: (value: T) => void, value: T) => void;
  };
}) => {
  const { data: settings, isPending } =
    useRoomCategoriesFiltersSettings(hotelId);

  const amenitiesOptions = useMemo(
    () => settings?.amenities.map((a) => ({ value: a, label: a })),
    [settings],
  );

  if (isPending) {
    return null;
  }

  return (
    <>
      <FilterSingleSelect
        value={filters.categoryId}
        placeholder="Categories"
        className="min-w-[140px] justify-between"
        options={[
          { value: "all categories", label: "Categories" },
          ...(settings?.categories.map((category) => ({
            value: category.id,
            label: category.name,
          })) || []),
        ]}
        onValueChange={(value) =>
          actions.handleFilterChange(actions.setCategoryId, value)
        }
      />

      <FilterMultiSelect
        className="min-w-[160px]"
        options={amenitiesOptions || []}
        placeholder={"Features"}
        value={filters.amenities || []}
        onValueChange={(value) =>
          actions.handleFilterChange(actions.setAmenities, value)
        }
      />
    </>
  );
};

export default RoomCategoriesFilter;
